import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const CustomButton = (props) => {
  let addCss = " ";
  let isLoading = props.isLoading;

  if (isLoading === true) {
    addCss += " btn-loading ";
  }

  return (
    <div className="text-center ">
      <div className={"btn-gradient" + addCss} onClick={props.onClick}>
        {props.title}
        {isLoading && (
          <Spin
            style={{ marginLeft: 5, marginRight: 5 }}
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 24,
                  color: "white",
                }}
                spin
              />
            }
          />
        )}
      </div>
    </div>
  );
};

export default CustomButton;
